import { jsPDF } from "jspdf";
import "jspdf-autotable";

// Helpers compartidos por los 4 reportes de utilidades (Venta, Artículo,
// Línea y Cliente) para que la tabla, el PDF y el correo digan lo mismo.

export const money = (v) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
  }).format(Number.isFinite(parseFloat(v)) ? parseFloat(v) : 0);

export const pct = (v) =>
  `${new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(
    Number.isFinite(parseFloat(v)) ? parseFloat(v) : 0
  )} %`;

export const num = (v) =>
  new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(
    Number.isFinite(parseFloat(v)) ? parseFloat(v) : 0
  );

// Mismo criterio que el back: margen sobre la venta con el signo de la utilidad
export const margen = (venta, costo) =>
  venta ? ((venta - costo) / Math.abs(venta)) * 100 : 0;

export const esDevolucion = (row) => row.movimiento === "Devolucion";

// "Nota" legible: en devoluciones dice de qué nota viene
export const notaTexto = (row) =>
  esDevolucion(row)
    ? `Dev ${row.surtido}${row.notaOrigen ? ` (Nota ${row.notaOrigen})` : ""}`
    : `${row.surtido}`;

const FORMATOS = { money, pct, num, text: (v) => (v == null ? "" : `${v}`) };

// columnas: [{ titulo, valor: (row) => any, tipo: "money"|"pct"|"num"|"text", total?: "suma"|"margen"|"promedioPrecio" }]
export function pdfUtilidades({ titulo, fechaInicio, fechaFin, columnas, filas }) {
  const sum = (f) => filas.reduce((t, r) => t + (parseFloat(f(r)) || 0), 0);
  const totVenta = sum((r) => r.precioTotal);
  const totCosto = sum((r) => r.costoTotal);
  const totCantidad = sum((r) => r.cantidad);

  const body = filas.map((r) =>
    columnas.map((c) => FORMATOS[c.tipo || "text"](c.valor(r)))
  );

  const foot = columnas.map((c, i) => {
    if (c.total === "suma") return FORMATOS[c.tipo](sum(c.valor));
    if (c.total === "margen") return pct(margen(totVenta, totCosto));
    if (c.total === "promedioPrecio")
      return money(totCantidad ? totVenta / totCantidad : 0);
    return i === 0 ? "TOTALES" : "";
  });

  const doc = new jsPDF({ orientation: columnas.length > 7 ? "landscape" : "portrait" });
  const ancho = doc.internal.pageSize.getWidth();
  const img = new Image();
  img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
  doc.addImage(img, "png", ancho - 50, 5, 33, 10);
  const img2 = new Image();
  img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
  doc.addImage(img2, "png", ancho - 45, 15, 25, 25);

  doc.setFontSize(14);
  doc.text(titulo, 15, 30);
  doc.setFontSize(10);
  doc.text(`${fechaInicio || ""} - ${fechaFin || ""}`, 15, 36);
  doc.text(
    "Venta neta de descuentos. Devoluciones en negativo (restan venta y costo).",
    15,
    41
  );

  doc.autoTable({
    head: [columnas.map((c) => c.titulo)],
    body,
    foot: [foot],
    showFoot: "lastPage",
    startY: 45,
    styles: { fontSize: 8 },
    didParseCell: (data) => {
      // devoluciones en rojo para distinguirlas de las ventas
      if (data.section === "body" && esDevolucion(filas[data.row.index] || {})) {
        data.cell.styles.textColor = [200, 30, 30];
      }
    },
  });
  return doc;
}
